import { render } from "./RecommendFoodNoticeToast.vue?vue&type=template&id=79a8e5d1&scoped=true&ts=true"
import script from "./RecommendFoodNoticeToast.vue?vue&type=script&lang=ts"
export * from "./RecommendFoodNoticeToast.vue?vue&type=script&lang=ts"

import "./RecommendFoodNoticeToast.vue?vue&type=style&index=0&id=79a8e5d1&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a8e5d1"]])

export default __exports__